import {createContext, useContext, ReactNode} from 'react';
import {UserModel} from "../features/user/UserModel";
import {useFetchUser} from "../features/user/userApi";

interface LoggedUserContextType {
    user: UserModel | null | undefined;
    isLoading: boolean;
}

const LoggedUserContext = createContext<LoggedUserContextType | undefined>(undefined);

export const LoggedUserProvider = ({ children }: { children: ReactNode }) => {
    const {data:user, isLoading} = useFetchUser();

    return (
        <LoggedUserContext.Provider value={{ user, isLoading}}>
            {children}
        </LoggedUserContext.Provider>
    );
};

export const useLoggedUser = () => {
    const context = useContext(LoggedUserContext);

    if (context === undefined) {
        throw new Error('Context is undefined');
    }

    return context;
};
